import React from 'react';
import { 
  Box, 
  Typography,
  Avatar
} from '@mui/material';
import { Phone } from '@mui/icons-material';

const EmptyCallsPageCard = ({ 
  title = "No Calls Found", 
  description = "No call records are available for the selected time period. Try adjusting your date range or filters to see more results.",
  isSearchActive = false,
  compact = false
}) => {

  return (
    <Box sx={{ 
      p: compact ? 2.5 : 4, 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: compact ? 120 : 200
    }}>
      <Avatar 
        sx={{ 
          bgcolor: 'rgba(33, 150, 243, 0.1)', 
          color: 'primary.main', 
          width: compact ? 60 : 80, 
          height: compact ? 60 : 80,
          margin: '0 auto',
          mb: compact ? 1.5 : 2,
          boxShadow: '0 4px 12px rgba(33, 150, 243, 0.2)',
          animation: 'phonePulse 2s ease-in-out infinite',
          '@keyframes phonePulse': {
            '0%': {
              transform: 'scale(1)',
              boxShadow: '0 4px 12px rgba(33, 150, 243, 0.2)'
            },
            '50%': {
              transform: 'scale(1.1)',
              boxShadow: '0 6px 20px rgba(33, 150, 243, 0.4)'
            },
            '100%': {
              transform: 'scale(1)',
              boxShadow: '0 4px 12px rgba(33, 150, 243, 0.2)'
            }
          }
        }}
      >
        <Phone 
          sx={{ 
            fontSize: compact ? 28 : 36,
            color: 'primary.main',
            animation: 'phoneRing 1.5s ease-in-out infinite',
            '@keyframes phoneRing': {
              '0%, 100%': {
                transform: 'rotate(0deg)'
              },
              '25%': {
                transform: 'rotate(-5deg)'
              },
              '75%': {
                transform: 'rotate(5deg)'
              }
            }
          }} 
        />
      </Avatar>
      
      <Typography 
        variant={compact ? "subtitle1" : "h6"} 
        color="text.primary" 
        sx={{ 
          fontWeight: 600, 
          mb: compact ? 0.5 : 1,
          fontSize: compact ? '0.875rem' : '1.125rem'
        }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body2" 
        color="text.secondary" 
        sx={{ 
          lineHeight: 1.6, 
          mb: compact ? 1.5 : 2,
          fontSize: compact ? '0.813rem' : '0.875rem',
          maxWidth: 350,
          textAlign: 'center'
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default EmptyCallsPageCard; 